import { TFunction } from 'i18next'

import { InvoiceDocumentType } from '@features/invoices/enums/invoiceDocumentType'

export const getIssueDateFieldLabel = (documentType: InvoiceDocumentType, t: TFunction) => {
  switch (documentType) {
    case InvoiceDocumentType.CreditNote:
      return t('external_invoices.editor.form.field.issue_date.credit_note.label')
    case InvoiceDocumentType.Quote:
      return t('external_invoices.editor.form.field.issue_date.quote.label')
    case InvoiceDocumentType.Invoice:
    default:
      return t('external_invoices.editor.form.field.issue_date.label')
  }
}
